<template>
  <div v-if="loggedIn" id="header-account">
    <h5 class="greeting">Hello, Cathy!</h5>
    <div id="avatar">
      <img id="avatar-image" src="@/assets/images/default-avatar.svg" />
      <div id="caret"></div>
    </div>
  </div>
  <div v-else id="header-account" class="logged-out">
    <HlButton className="primary" label="Sign up" link="#" />
    <h5>or</h5>
    <HlButton className="secondary" label="Log in" link="#" />
  </div>
</template>

<script>
export default {
  name: "HeaderAccount",
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn;
    }
  }
};
</script>

<style lang="stylus" scoped>
#header-account
  background: linear-gradient(to bottom, #f05f38 0%,#d85633 100%)
  position: relative
  z-index: 5
  max-width: 300px
  height: 90px
  margin-left: 40px
  margin-right: -30px
  padding-left: 20px
  padding-right: 23px
  display: flex
  align-items: center
  justify-content: center
  .greeting
    display: none
  @media only screen and (min-width: 900px)
    .greeting
      display: block
  .button
    color: #FFF
    border-color: #FFF
    &.primary
      background: #FFF
      color: #f05f38
    &.secondary
      border: none;
      text-decoration: underline
      padding: 0px
  #avatar
    width: auto
    height: 90px
    display: flex
    padding: 0px 10px
    align-items: center
    cursor: pointer
    transition: all 250ms
    @media only screen and (min-width: 900px)
      margin-left: 10px
    #avatar-image
      height: 45px
    #caret
      width: 10px
      height: 90px
      background-image: url("../assets/images/down-caret.svg")
      background-repeat: no-repeat
      background-position: center center
    &:hover
      background: rgba(0,0,0,0.15)
  h5
    font-family: "Montserrat"
    font-size: 14px
    font-weight: 600
    color: #FFF
    margin: 0px
  &:before
    content: ''
    height: 90px
    width: 23px
    position: absolute
    top: 0px
    left: -22px
    background-image: url('../assets/images/header-endcap.svg')
    background-size: auto 100%
  &.logged-out
    h5
      margin: 0px 10px
</style>
